import { memo } from 'react';
import styled from 'styled-components';
import breakpoints from '../../utilities/breakpoints';
import InputField, { type InputFieldProps } from './InputField';

export const OutlinedDiv = styled.div`
    height: 100%;
    & .ant-form-item {
        border: 1px solid ${({ theme }) => theme.customerDetailsTheme.borderColor};
        padding: 10px 15px;
        margin: 0px;
        height: 100%;

        @media screen and (max-width: ${breakpoints.lg}) {
            height: auto;
        }
    }

    & .ant-form-item-label {
        padding: 0px;
        margin: 0px;
    }

    & .ant-input-prefix {
        color: ${({ theme }) => theme.customerDetailsTheme.inputPrefixColor};
    }
`;

const OutlinedInputField = ({ name, ...props }: InputFieldProps) => (
    <OutlinedDiv>
        <InputField name={name} {...props} />
    </OutlinedDiv>
);

export default memo(OutlinedInputField);
